import MondayDemoTabsComponent from "./monday-demo-tabs-component";
import MondayDemoTabsConfig from "./monday-demo-tabs-config";
import MondayDemoTabsAdvancedConfig from "./monday-demo-tabs-advanced-config";

export default {
  MondayDemoTabsComponent,
  MondayDemoTabsConfig,
  MondayDemoTabsAdvancedConfig
};
